
import axios from "axios";
import store from "../../store/index";
import customModal from "../customModal/customModal.vue";

export default {
    name:'sdvDiscrepancyModel',
    props: {
        sdvPayload : {
            type: Object,
            default: () => ({}),
        },
        fromTab: {
            type: String,
            default: 'dataSignal', 
        },

    },
    components: {
        customModal,
    },
    data(){
        return{
            baseurl: process.env.VUE_APP_Service_URL,
            idToken: store.getters.getIdToken,
            headerValues: {},
            reasonsList: [],   
        };
    },
    async mounted(){
        console.log("hi...")
        this.headerValues = {
            headers: {
                Authorization: "Bearer " + this.idToken,
                "Content-Type": "application/json",
            },
        };
        await this.getReasons();
    },
    methods: {
        closeDisModal() {
            this.$emit('closeModal');
        },
        async getReasons(){
            try{
                let url = `${this.baseurl}/stats-python/formstatistics/getalldiscrepancyreasons`;
                let response = await axios.get(url, this.headerValues);
                this.reasonsList = response.data;
                console.log("reasons data.......", this.reasonsList);
            }
            catch(error){
                console.log("error to get reasons...", error);
            }
        },
        async verifySourceData(){
            console.log("frompage...", this.fromTab);
            try{
                const result = await axios.put(`${this.baseurl}/forms/rbqm/updatesdvitem`,this.sdvPayload,this.headerValues);                
                alert(this.$t('navigations.submitted successfully'));
                console.log("verify source data result", result);
                this.closeDisModal();
            }
            catch(error){
                console.error("Error in verify source data:", error);
            }
        },
    },
}